// extracted by mini-css-extract-plugin
export default {"center":"ReactIcon_center__TY9sc","App-logo":"ReactIcon_App-logo__bxcce","App-logo-spin":"ReactIcon_App-logo-spin__a4Cd4"};